<div [style.background-image]="'url(' + appConfig.statics.background + ')'" class="app-account full-height-scroll">
  <feature-notification-handling-notification></feature-notification-handling-notification>
  <img src="{{ appConfig.statics.logo }}" />

  <div class="middle-box text-center loginscreen animated fadeInDown">
    <form [formGroup]="formGroup" class="m-t">
      <div class="mb-3">
        <h3>{{ 'card-title-registration' | translate }}</h3>
        <div class="form-group app-account-email fw-bold">
          <label class="control-label">{{ email }}</label>
        </div>
      </div>
      <div class="form-group mb-3">
        <shared-ui-inputs-input-group
          [tabIndex]="1"
          [parentFormGroup]="formGroup"
          [formName]="'firstName'"
          [name]="'input-or-field-label-first-name' | translate"
          [placeholder]="'input-or-field-label-first-name' | translate"
          [showLabel]="false"
        ></shared-ui-inputs-input-group>
      </div>
      <div class="form-group mb-3">
        <shared-ui-inputs-input-group
          [tabIndex]="2"
          [parentFormGroup]="formGroup"
          [formName]="'lastName'"
          [name]="'input-or-field-label-last-name' | translate"
          [placeholder]="'input-or-field-label-last-name' | translate"
          [showLabel]="false"
        ></shared-ui-inputs-input-group>
      </div>
      <div class="form-group mb-3">
        <shared-ui-inputs-phone-input
          [parentFormGroup]="formGroup"
          [formName]="'phoneNumber'"
          [name]="'input-or-field-label-phone-number' | translate"
          [display]="inputDisplay.Inline"
        >
        </shared-ui-inputs-phone-input>
      </div>
      <div class="form-group mb-3">
        <shared-ui-inputs-select-field
          [tabIndex]="4"
          [options]="timeZonesOptions"
          [parentFormGroup]="formGroup"
          [formName]="'timezone'"
          [name]="'select-or-field-label-time-zone' | translate"
          [setDefaultValue]="true"
          [resettable]="false"
          [filter]="true"
        >
        </shared-ui-inputs-select-field>
      </div>
      <div class="form-group mb-3 position-relative">
        <shared-ui-inputs-input-group
          [tabIndex]="5"
          [parentFormGroup]="formGroup"
          [formName]="'password.password'"
          [name]="'input-new-password' | translate"
          [type]="inputFieldType.Password"
          [placeholder]="'input-new-password' | translate"
          [showLabel]="false"
        >
        </shared-ui-inputs-input-group>
        <shared-ui-inputs-password-info></shared-ui-inputs-password-info>
      </div>
      <div class="form-group mb-3">
        <shared-ui-inputs-input-group
          [tabIndex]="6"
          [parentFormGroup]="formGroup"
          [formName]="'password.confirmPassword'"
          [name]="'input-confirm-password' | translate"
          [type]="inputFieldType.Password"
          [placeholder]="'input-confirm-password' | translate"
          [showLabel]="false"
        >
        </shared-ui-inputs-input-group>
        <span *ngIf="!formGroup.get('password')?.valid && formGroup.get('password')?.dirty" class="invalid-feedback d-block">{{ 'default-not-matched-field' | translate }}</span>
      </div>
      <div class="from-group mb-3 app-account-terms">
        <span>{{ 'terms-and-policy-message-part-one' | translate }}</span>
        <b
          ><a [href]="'tenant-web-page-two' | translate" target="_blank"> {{ 'terms-and-policy-message-part-two' | translate }}</a></b
        >
      </div>
      <shared-ui-buttons-button
        class="mb-3"
        [disabled]="!formGroup.valid || !phoneInput?.isNumberValid()"
        [tabIndex]="7"
        [text]="'button-register' | translate"
        [type]="buttonType.Primary"
        [size]="buttonSize.Default"
        (action)="onRegister()"
      ></shared-ui-buttons-button>
    </form>
    <div class="text-light mt-3 center-foolter">
      {{ 'register-page-description' | translate }}
      <b>
        <a target="_blank" [href]="'tenant-web-page' | translate">{{ 'tenant-web-page-clickable-text' | translate }}</a>
      </b>
      <div class="m-t-sm">&copy; {{ 'tenant-copyrights' | translate }} {{ date.getFullYear() }}</div>
    </div>
  </div>
</div>
